module.exports = __webpack_public_path__ + "img/Academic_Text.0e61b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Academic_Text.png
// module id = 582
// module chunks = 5